import {
  NgModule,
  Optional,
  SkipSelf,
  ErrorHandler,
  Injector,
  APP_INITIALIZER,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HttpClient } from '@angular/common/http';

import { ToastrModule } from 'ngx-toastr';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AnimationsService } from './animations/animations.service';
import { Title } from '@angular/platform-browser';
import { _HttpInterceptorProviders } from './http-interceptors';
import { CanDeactivateGuard } from './can-deactivate.guard';
import { LocalstorageService } from './Localstorage.service';
import { CoreConfigService } from './core.service';
import { Setting_Model } from './core.model';
import { AppComponent } from '../app.component';
import { StartupService } from '../core/startup.service';
import { HomeComponent } from '../home/home.component';


export function initApp(_StartupService: StartupService) {
  return () => {
    _StartupService.GetRuntimeConfig();
  };
}
@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-right',
      timeOut: 5000,
      closeButton: true,
      extendedTimeOut: 5000,
      progressBar: true,
    }),

    // 3rd party
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  declarations: [
  ],
  providers: [
    AnimationsService,
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      multi: true,
      deps: [StartupService],
    },
    Title,
    _HttpInterceptorProviders,
    CanDeactivateGuard,
  ],
  exports: [TranslateModule],
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule
  ) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import only in AppModule');
    }
  }
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, `./assets/i18n/`, '.txt');
}
